/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    call, put, select, take,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';

import { errorOperations } from '../../../../../Checkout/ducks/Common/ducks/Error';

import { flagOffShowLoadingMessage, updateShowLoadingMessage } from '../../../../../Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';

import { callHandleCartFailure, cartLoaded, loadCart } from '../../Cart-Actions';
import { loadCartCount } from '../../../../../Order/Order-Actions';

import cartServiceClient from '../../../../../../../apis/cart-service-apis/cartServiceClient';
import { checkJWT } from '../../../../../Member/ducks/Auth/Auth-Operations';
import { getOrderId } from '../../Cart-Selectors';
import { getFeatureFlags, getOnePageCheckoutSaleForceABTest } from '../../../App/App-Selectors';
import { continueToPayment } from '../../../../../Checkout/ducks/Common/Common-Selectors';
import { triggerValidateOrder, triggerValidateOrderCompleted } from '../ValidateCart/ValidateCart-Actions';

function* retrieveCart(isPlaceOrder, skipValidateCart) {
    const cartId = yield select(getOrderId);
    try {
        // const cartErrors = yield select(getOrderItemErrors);

        yield put(updateShowLoadingMessage());

        if (cartId) {
            const flagState = yield select(getFeatureFlags);
            // we remove this because is cleaning the errors when we do prepare cart.
            // if (cartErrors?.[cartId]?.cart) {
            //     yield put(clearOrderItemErrors(
            //         cartId,
            //         'cart',
            //         { errType: 'clearAllFields', field: '' },
            //     ));
            // }

            const jwtToken = yield call(checkJWT);
            const object = {
                envObj: {},
                jwtToken,
                cartId,
            };

            const isContinueToPayment = yield select(continueToPayment);
            const onePageCheckout = yield select(getOnePageCheckoutSaleForceABTest) || {};
            const isOnePageCheckoutEnabled = flagState['is-one-page-checkout-enabled'] === 'newflow'
                || (
                    flagState['is-one-page-checkout-enabled'] === 'salesforce'
                    && onePageCheckout?.campaign?.campaignResponses?.[0]?.userGroup === 'Default'
                );
            const cartResponse = yield call(cartServiceClient.getCartOrderDetails, object);
            const cartCount = cartResponse?.data?.orderSize ? Number(cartResponse.data.orderSize) : 0;

            if (isPlaceOrder) {
                if (flagState['is-checkout-monitoring-enabled']) {
                    mbpLogger.logError({
                        function: 'retrieveCart',
                        appName: process.env.npm_package_name,
                        module: 'mbp-checkout',
                        message: `retrieveCart response - cart API ${cartId}`,
                        orderId: cartId,
                        jsError: cartResponse.data,
                        errorMessage: cartResponse.data,
                    });
                }
            }

            yield put(loadCartCount(Number(cartCount)));
            yield put(loadCart(cartResponse.data));

            if (
                isOnePageCheckoutEnabled
                && isContinueToPayment
                && !skipValidateCart
                && window?.location?.pathname?.indexOf('/shipping') >= 0
            ) {
                yield put(triggerValidateOrder({ location: { pathname: '/checkout/shipping' } }, null, 'single-payment-review'));
                yield take(triggerValidateOrderCompleted().type);
            }

            // Success
            yield put(cartLoaded());
        }

        yield put(flagOffShowLoadingMessage());
    } catch (ex) {
        if (ex.response?.errorKey !== 'ERROR_CART_NOT_FOUND') {
            mbpLogger.logError({
                function: 'retrieveCart',
                appName: process.env.npm_package_name,
                module: 'mbp-pwa-ui',
                jsError: ex,
                message: 'RetrieveCart API failed',
                cartId,
            });
        }
        yield call(errorOperations.processFeatureErrors, ex, 'cart');

        // The cart dosnt have authorization anymore in the session.
        yield put(callHandleCartFailure(ex));

        // End loader
        yield put(flagOffShowLoadingMessage());
    }
}

export {
    retrieveCart,
};

export default {};
